import { entityDetail, postalCode } from "./Entity";

export const initialState = {
  entity: entityDetail,
  isFetching: false,
  postalAreas: [],
  municiples: [],
  selectedPostalAreaDetail: {},
  selectedMunicipality: [],
  initialCodeData: postalCode,
  existingCode: postalCode,
  isSaving: false,
  isSaveSuccess: false,
  isExisitingCode: false,
  countries: {
    data: [],
    isLoading: false,
  },
  isMunicipalsLoading: false,
  isPostalAreasLoading: false,
};
